

const getCvg = () => {
    if (window['cvg']) {
        return window['cvg'];
    }
    const cvg = window['cvg'] = function() {
        // if the pixel has loaded, pass the argument through to it
        // if the pixel has not loaded yet, queue the calls in an array
        cvg.queue = cvg.queue || [];
        cvg.process ? cvg.process.apply(cvg, arguments) : cvg.queue.push(arguments)
    }
    return cvg;
}

const track = ({event, properties, eventId, profileProperties, aliases}) => {
    getCvg()({
        method: 'track',
        eventName: event,
        properties,
        eventID: eventId,
        profileProperties,
        aliases
    });
}

module.exports = {
    cvgTrack: track
}
